<template>
  <div v-if="dataPermission.includes('CNPS_CALENDAR_WK_TASK_INSERT')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Thêm mới danh mục công việc</h1>
      <div style="float: right">
        <button class="btn btn-light" @click="cancelModal = true">Hủy bỏ</button>
        <button class="btn btn-success btn-primary ml-2" @click="addCalendar">Thêm mới</button>
      </div>
    </div>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
    <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: auto overflow-y: auto">
      <div class="card-body px-20 row">
        <ValidationObserver class="w-100" ref="formAdd">
          <form class="col-md-6" @submit.prevent="addCalendar">
            <ValidationProvider rules="required" vid="wkGroupId" name="Nhóm công việc">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Nhóm công việc<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <Select2 v-model="dataInsert.wkGroupId" :options="optionGroup"></Select2>
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|minMaxName_2" vid="taskName" name="Tên công việc">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Tên công việc<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.taskName" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|inputLimit50" vid="taskCode" name="Mã công việc">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Mã công việc<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.taskCode" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="maxReceipt_2" vid="note" name="Mô tả">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label">Mô tả</label>
                <div class="col-sm-8">
                  <input v-model="dataInsert.note" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|regexNumber1" vid="level" name="Cấp độ">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Cấp độ<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.level" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|maxReceipt_3"
              vid="reviewTime"
              name="Thời gian đánh giá điểm"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Thời gian đánh giá điểm<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model="dataInsert.reviewTime" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              rules="required|maxReceipt_3"
              vid="condition"
              name="Điều kiện đánh giá hoàn thành"
            >
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Điều kiện đánh giá hoàn thành<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model="dataInsert.condition" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider rules="required|regexNumber" vid="point" name="Điểm đánh giá">
              <div class="form-group row" slot-scope="{ errors }">
                <label for="" class="col-sm-4 col-form-label"
                  >Điểm đánh giá<span style="color: red"> *</span></label
                >
                <div class="col-sm-8">
                  <input v-model.trim="dataInsert.point" type="text" class="form-control" />
                  <p class="text-danger">{{ errors[0] }}</p>
                </div>
              </div>
            </ValidationProvider>
            <div class="form-group row">
              <label for="" class="col-sm-4 col-form-label">Loại công việc</label>
              <div class="col-sm-8">
                <Select2 v-model="dataInsert.type" :options="optionPurpose"></Select2>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <b-modal id="modal-scoped" v-model="showModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()" v-if="errorAdd"> Đóng </b-button>
        <b-button size="sm" variant="success" @click="backToList" v-else> Đóng </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="addModal">
      <template #modal-header="{ close }">
        <h5>Thêm danh mục công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn thêm danh mục công việc này ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="confirmAdd"> Xác nhận </b-button>
      </template>
    </b-modal>

    <b-modal id="modal-scoped" v-model="cancelModal">
      <template #modal-header="{ close }">
        <h5>Huỷ thêm danh mục công việc</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <h2 class="f18 py-3">Bạn chắc chắn muốn huỷ ?</h2>
      </div>
      <template #modal-footer="{ close }">
        <b-button size="sm" variant="light" @click="close()"> Đóng </b-button>
        <b-button size="sm" variant="primary" @click="backToList"> Xác nhận </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { CalendarAfsService } from '@/services/calendar-afs.service'
  import { mapGetters } from 'vuex'
  import Config from '@/thirdParty/config'

  export default {
    data() {
      return {
        dataInsert: {},
        msgNoti: '',
        iconNoti: '',
        showModal: false,
        optionGroup: [],
        optionPurpose: Config.typePurposeOption || [],
        errorAdd: false,
        addModal: false,
        cancelModal: false,
        loading: false,
      }
    },
    created() {
      this.groupList()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // add cv
      async addCalendar() {
        const isSuccess = await this.$refs.formAdd.validate()
        if (!isSuccess) {
          return
        }
        this.addModal = true
      },
      async confirmAdd() {
        this.addModal = false
        try {
          this.loading = true
          const data = await CalendarAfsService.addCatCalendar(this.dataInsert)
          if (data.success) {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.msgNoti = 'Thêm danh mục công việc thành công'
          } else {
            this.showModal = true
            this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
            this.msgNoti = data.message
            this.errorAdd = true
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      backToList() {
        this.$router.push('/cat-calendar-afs')
      },
      async groupList() {
        try {
          const data = await CalendarAfsService.groupCalendar({
            page: 1,
            size: 1000,
          })
          if (data.success) {
            this.optionGroup = data.data.map(e => {
              return {
                id: e.id,
                text: e.groupName,
              }
            })
          }
        } catch (error) {
          console.log(error)
        }
      },
    },
  }
</script>
